import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';
/**
 * Хук для управления состоянием аккордеона. Если в проп `open` было передано булево значение,
 * то компонент переходит в режим управляемого (состояние снаружи).
 */
export var useAccordionState = function useAccordionState(_ref) {
  var open = _ref.open,
    defaultOpen = _ref.defaultOpen,
    onClick = _ref.onClick;
  var _useState = useState(!!open || !!defaultOpen),
    _useState2 = _slicedToArray(_useState, 2),
    _open = _useState2[0],
    _setOpen = _useState2[1];
  var _useState3 = useState(open !== undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    _controlled = _useState4[0],
    _setControlled = _useState4[1];

  /* Переключение режимов управляемый/неуправляемый */
  useEffect(function () {
    _setControlled(open !== undefined);
  }, [open]);
  var clickHandler = function clickHandler() {
    if (!_controlled) {
      _setOpen(!_open);
    }
    onClick === null || onClick === void 0 ? void 0 : onClick(!_open);
  };
  return {
    isOpen: _controlled ? !!open : _open,
    clickHandler: clickHandler
  };
};